import { Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { IDataDashboardReceituario } from "../../../../../types/api/receituarioAgronomico/dashboard-receituario";
import SelectQuery from "../../../../../components/SelectQuery";
import React, { useContext } from "react";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { IDataLojas } from "../../../../../types/api/geral/pesquisar-lojas";


export default function CardDadosDashboard({
    dataDashboard,
    loja,
    onChangeLoja,
}: CardDadosDashboardProps) {
    
    const { userPerfilComLoja } = useContext(AuthContext);

    return (
        <PaperBox sx={{ height: '100%' }} p={2}>
            <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography variant='h6'>Quantidade de receitas emitidas</Typography>
                <Box justifySelf={'flex-end'} paddingTop={1}>
                    <SelectQuery
                        defaultValue={loja ? [loja] : []}
                        query="pesquisar-lojas"
                        type="field"
                        label="Loja"
                        titleModal="Selecionar Loja"
                        emptyLabel="-"
                        multiple={false}
                        permitirLimpar={false}
                        returnOnlyId={false}
                        autoSelectFirst
                        onChange={(values) => {
                            onChangeLoja(values[0] || null);
                        }}
                        extraParams={{ somente_vinculadas: Boolean(userPerfilComLoja?.loja) }}
                    />
                </Box>
            </Stack>
            {
                dataDashboard &&
                <Grid container spacing={2} mt={1}>
                    <Grid size={{xs: 12}}>
                        <Stack direction="row" gap={4} spacing={2} justifyContent={"space-evenly"}>
                            <Box>
                                <Typography mb={0.5}>Hoje</Typography>
                                <Typography textAlign={'right'} fontWeight="bold" fontSize={28}>
                                    {`${dataDashboard.qtd_receitas_emitidas.hoje || '0'}`}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography mb={0.5}>Últimos 7 dias</Typography>
                                <Typography textAlign={'right'} fontWeight="bold" fontSize={28}>
                                    {`${dataDashboard.qtd_receitas_emitidas.ultimos_7_dias || '0'}`}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography mb={0.5}>Últimos 30 dias</Typography>
                                <Typography textAlign={'right'} fontWeight="bold" fontSize={28}>
                                    {`${dataDashboard.qtd_receitas_emitidas.ultimos_30_dias || '0'}`}
                                </Typography>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            }
        </PaperBox>
    );
}


interface CardDadosDashboardProps {
    dataDashboard: IDataDashboardReceituario;
    onChangeLoja: (loja: IDataLojas | null) => void;
    loja: IDataLojas | null;
}